(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.UndoService = (function(superClass) {
    extend(UndoService, superClass);

    function UndoService(rootScope) {
      this.rootScope = rootScope;
      this.update = bind(this.update, this);
      this.undo = bind(this.undo, this);
      this.stack = [];
      this.button_name = 'draw-undo';
    }

    UndoService.prototype.setDrawControl = function(drawControl) {
      this.drawControl = drawControl;
      return this.updateButtonStatus();
    };

    UndoService.prototype.enable = function() {
      if (this.drawControl != null) {
        return this.drawControl.enableBtn(this.button_name);
      }
    };

    UndoService.prototype.disable = function() {
      if (this.drawControl != null) {
        return this.drawControl.disableBtn(this.button_name);
      }
    };

    UndoService.prototype.updateButtonStatus = function() {
      if (this.stack.length) {
        return this.enable();
      } else {
        return this.disable();
      }
    };

    UndoService.prototype.undo = function() {
      if (this.canUndo()) {
        this.updateMap(this.getPreviousRemove());
        return this.updateButtonStatus();
      }
    };

    UndoService.prototype.update = function(previous) {
      this.previous = previous;
      this.appendStack(this.previous);
      return this.updateButtonStatus();
    };

    UndoService.prototype.appendStack = function() {
      return this.stack.push(this.previous);
    };

    UndoService.prototype.getPreviousRemove = function() {
      return this.stack.pop();
    };

    UndoService.prototype.canUndo = function() {
      return (this.previous != null) && this.stack.length && (this.drawControl != null);
    };

    UndoService.prototype.cleanup = function() {
      this.previous = null;
      this.stack = [];
      return this.updateButtonStatus();
    };

    UndoService.prototype.updateMap = function(layer) {
      return this.drawControl._finishDrawing(layer, (function(_this) {
        return function() {
          return _this.rootScope.$broadcast('mfdraw:apply');
        };
      })(this), false);
    };

    return UndoService;

  })(Service);

}).call(this);
